import React, { useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";

const BookingForm = () => {
  const form = useRef();
  const { t } = useTranslation();
  const location = useLocation();

  const today = new Date().toISOString().split("T")[0];

  const roomNumber = location.state?.roomNumber || "";
  const roomType = location.state?.roomType || "";

  const [formdata, setFormdata] = useState({
    book_name: "",
    book_mobile: "",
    room_type: roomType,
    room_number: roomNumber,
    book_check_in: today,
    book_check_out: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormdata((prev) => ({ ...prev, [name]: value }));
  };
  
    const submitForm = async (e) => {
      e.preventDefault();

  
      try {
        const response = await axios.post(
          "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/add_booking",
          formdata,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
  
        console.log("API response:", response.data);
  
        if (response.data.success === 1) {
          toast.success(response.data.message ||  "Message submitted successfully!");
          setFormdata({
            book_name: "",
            book_mobile: "",
            room_type: roomType,
            room_number: roomNumber,
            book_check_in: today,
            book_check_out: "",
          });
        } else {
          toast.error("Submission failed!");
        }
      } catch (error) {
        console.error("Submission error:", error);
        toast.error("Something went wrong!");
      }
    };

  return (
    <div>
      <div className="col-xl-6 col-lg-6 offset-xl-3 offset-lg-1">
        <div className="booking-form">
          <h3>{t("bookingTitle")}</h3>
          <span className="booking-room-numbers-section">
            {roomNumber && `${roomNumber}`}
          </span>

          {roomType && (
            <div className="booking-room-info">
              <h4>{roomType}</h4>
            </div>
          )}

          <Link to="/book-now">
            <span className="booking-form-close">
              <i className="fa-solid fa-xmark" />
            </span>
          </Link>
          <form ref={form} onSubmit={submitForm} className="row">
            <div className="col-lg-6 check-date">
              <label htmlFor="book_name">{t("name")}</label>
              <input
                type="text"
                id="book_name"
                name="book_name"
                placeholder={t("enter_name")}
                value={formdata.book_name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-lg-6 check-date">
              <label htmlFor="book_mobile">{t("number")}</label>
              <input
                type="number"
                id="book_mobile"
                name="book_mobile"
                placeholder={t("enter_number")}
                value={formdata.book_mobile}
                onChange={handleChange}
                required
                min="1"
              />
            </div>

            <div className="col-lg-6 check-date">
              <label htmlFor="book_check_in">{t("check_in")}:</label>
              <input
                type="date"
                id="book_check_in"
                name="book_check_in"
                value={formdata.book_check_in}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-lg-6 check-date">
              <label htmlFor="book_check_out">{t("check_out")}:</label>
              <input
                type="date"
                id="book_check_out"
                name="book_check_out"
                value={formdata.book_check_out}
                onChange={handleChange}
                required
              />
            </div>
            <button type="submit">{t("book_now")}</button>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default BookingForm;
